import React from "react";
import { Link } from "react-router-dom";
import { pages, socials } from "../pages";

import ChangeOfUnit from "./ChangeOfUnit";
import { IoCloseSharp } from "react-icons/io5";
import { useMediaQuery } from "react-responsive";

import { LogoContent, SideBannerContainer, SocialContainer, MenuItemContainer, SocialIcon, MenuItemWrap, MenuItemText, IconCloseWrap } from "./styles";

const SideBanner = ({ showMenu, setShowMenu }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <SideBannerContainer showMenu={showMenu}>
      {isMobile && (
        <IconCloseWrap>
          <IoCloseSharp onClick={() => setShowMenu(false)} size={16} />
        </IconCloseWrap>
      )}
      <LogoContent>
        <Link to="/">
          <img
            width={173.42}
            src="/static/ultragaz-logo-white.svg"
            alt="Logo da Ultragaz"
            />
        </Link>
      </LogoContent>
      <ChangeOfUnit />
      <MenuItemContainer>
        {pages().map((page) => {
          const Icon = page.icon;

          return (
            <MenuItemWrap key={page.name}>
              <Icon />
              <MenuItemText>{page.name}</MenuItemText>
            </MenuItemWrap>
        );
        })}
      </MenuItemContainer>
      <SocialContainer>
        {socials?.map((social) => (
          <SocialIcon
            key={social?.href}
            href={social?.href}
            target="_blank"
            aria-label={social?.alt}
            rel="external"
          >
            <img src={social?.img} alt={social?.alt} />
          </SocialIcon>
        ))}
      </SocialContainer>
    </SideBannerContainer>
  );
}

export default SideBanner;
